import { render } from "./ModalPaymentHistory.vue?vue&type=template&id=34320c05&scoped=true"
import script from "./ModalPaymentHistory.vue?vue&type=script&lang=js"
export * from "./ModalPaymentHistory.vue?vue&type=script&lang=js"

import "./ModalPaymentHistory.vue?vue&type=style&index=0&id=34320c05&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34320c05"]])

export default __exports__